import { useEffect, useState } from "react";
import { Link } from "@/components/LLink";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "@/i18n";

const KEY = "hm-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const timer = setTimeout(() => setVisible(true), 1400);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("hm-cookie-banner", { detail: visible }));
  }, [visible]);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-3 bottom-3 z-[110] mx-auto max-w-3xl rounded-2xl border border-ink/10 bg-surface/95 shadow-2xl shadow-black/15 backdrop-blur-xl sm:inset-x-4 sm:bottom-4"
        >
          <div className="flex flex-col gap-4 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-6">
            <p className="text-sm leading-relaxed text-ink/65 sm:max-w-md">
              {t("cookie_text")}{" "}
              <Link to="/politica-cookies" data-testid="cookie-banner-policy-link" className="font-medium text-gold underline underline-offset-4">
                {t("footer_cookies")}
              </Link>
            </p>
            <div className="flex flex-col gap-2.5 sm:flex-row">
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="btn-sweep rounded-full bg-ink px-5 py-3 text-[11px] font-semibold uppercase tracking-widest text-base transition-colors sm:py-2.5"
              >
                {t("cookie_accept")}
              </button>
              <button
                onClick={() => choose("essential")}
                data-testid="cookie-essential-button"
                className="rounded-full border border-ink/20 px-5 py-3 text-[11px] font-semibold uppercase tracking-widest text-ink/70 transition-colors hover:border-ink hover:text-ink sm:py-2.5"
              >
                {t("cookie_essential")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
